<template>
    <div class="profile-progress-bar">
        <el-progress :stroke-width="24" :percentage="percentage" :text-inside="true" :color="progressColor">
            <span>{{ duration }}</span>
        </el-progress>
    </div>
</template>

<script>
export default {
    props: {
        percentage: {
            type: Number,
            required: true,
        },
        duration: {
            type: String,
            required: true,
        },
        mainFilters: {
            type: Array,
            required: false,
        },
        tagId: {
            type: Number,
            required: false,
        }
    },
    computed: {
        progressColor() {
            if (this.mainFilters && this.tagId) {
                const filter = this.mainFilters.find(f => f.id == this.tagId);
                return filter ? filter.color : "#bababa";
            }
            return '#bababa';
        }
    },
};
</script>

<style scoped>
.profile-progress-bar {
    width: 100%;
    max-width: 600px;
    color: #000;
    margin-bottom: 15px;
}

.profile-progress-bar ::v-deep(.el-progress-bar__outer) {
    border-radius: 18px !important;
    height: 10px !important;
}

.profile-progress-bar ::v-deep(.el-progress-bar__inner) {
    border-radius: 18px !important;
    text-align: left;
}

.profile-progress-bar ::v-deep(.el-progress-bar__innerText) {
    color: #000;
    font: normal normal medium 14px/17px Barlow;
}
</style>
